import React from "react"
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';

const RebarProjectPurchasableContainer = ({
    id,
    name,
    theoreticalWeight,
    unitPrice,
    unitDiscount,
    purchasable,
    i18n,
    t
}) => {
    const purchasableContainer = <Container>

        <Row>
            <Col md={{ offset: 2, span: 8 }}>
                <Container className='text-center border p-2 mb-3 bg-white'>
                    {t("Bu proje için kesim planları oluşturabilmek için ödeme yapmanız gerekmektedir.")}
                </Container>
            </Col>
        </Row>
        <Row className='mt-2'>
            <Col md={{ offset: 3, span: 6 }}>
                <Button style={{ backgroundColor: '#318CE7' }} className='p-3 border' href={`/${i18n.language}/project-purchase/${id}`}>
                    <h5>{t("projectdetails_paynote1")}({name}){t("projectdetails_paynote2")}</h5>
                    <div>
                        {unitDiscount !== 0 ?
                            <>
                                <div className='d-flex justify-content-center align-items-center'>
                                    <s style={{ fontSize: "17pt", fontWeight: "400", alignItems: "center" }} >{Math.floor(theoreticalWeight * (unitDiscount + unitPrice) * 1e-3)}₺</s>
                                    <s style={{ fontSize: "6pt", marginLeft: "10px" }}> ({(unitDiscount + unitPrice)} ₺/ton)</s>
                                    <span className='ms-2'>{t("inactive_yerine")}</span>
                                </div>
                            </>
                            :
                            <></>}
                        <div className='mb-2'>
                            <span style={{ fontSize: "32pt", fontWeight: "600" }}>{Math.floor(theoreticalWeight * unitPrice * 1e-3)}₺</span>
                            <div style={{ fontSize: "9pt" }}> ({(theoreticalWeight / 1000).toFixed(3)} ton &times; {unitPrice} ₺/ton)</div>
                        </div>
                    </div>

                    <p>{t("Ödeme yaptıktan sonra bu proje için istediğiniz kadar kesim planı oluşturabilir ve detaylarını elde edebilirsiniz.")}</p>
                </Button>
            </Col>
        </Row>

    </Container>

    const notPurchasableContainer = <Container>
        <Row>
            <Col md={{ offset: 2, span: 8 }}>
                <Container className='text-center border p-2 mb-3 bg-white'>
                    {t("projectdetails_orderednote1")}<a href={`/${i18n.language}/project-purchase/${id}`}>{t("projectdetails_orderednote2")}</a>{t("projectdetails_orderednote3")}
                </Container>
            </Col>
        </Row>
    </Container>

    return purchasable ? purchasableContainer : notPurchasableContainer;
}

export default RebarProjectPurchasableContainer;